const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2400 2400",
    style: {
      enableBackground: "new 0 0 2400 2400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000155134041875435874390000016269759390070159245_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M533.6,0.6H69.3C34-1.9,3.3,24.7,0.8,60c-0.2,3.1-0.2,6.1,0,9.2v464.3 c-3.8,35.2,21.7,66.8,56.9,70.6c3.9,0.4,7.7,0.5,11.6,0.2h466.5c35.3,2.6,66.1-23.8,68.7-59.2c0.3-3.9,0.2-7.7-0.2-11.6V71.4 c3.9-35.2-21.5-66.9-56.7-70.8C543,0.1,538.3,0.1,533.6,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M533.6,898.3H69.3c-35.3-2.5-66,24-68.5,59.4c-0.2,3.1-0.2,6.1,0,9.2v464.3 c-3.8,35.2,21.7,66.8,56.9,70.6c3.9,0.4,7.7,0.5,11.6,0.2h466.5c35.3,2.6,66.1-23.8,68.7-59.2c0.3-3.9,0.2-7.7-0.2-11.6V969.1 c3.9-35.2-21.5-66.9-56.7-70.8C543,897.8,538.3,897.8,533.6,898.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M533.6,1796H69.3c-35.3-2.5-66,24-68.5,59.4c-0.2,3.1-0.2,6.1,0,9.2v464.3 c-3.8,35.2,21.7,66.8,56.9,70.6c3.9,0.4,7.7,0.5,11.6,0.2h466.5c35.3,2.6,66.1-23.8,68.7-59.2c0.3-3.9,0.2-7.7-0.2-11.6v-462.1 c3.9-35.2-21.5-66.9-56.7-70.8C543,1795.5,538.3,1795.5,533.6,1796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M1502.1,533.5V71.4c3.9-35.2-21.5-66.9-56.7-70.8c-4.7-0.5-9.4-0.5-14,0H967 c-35.3-2.5-66,24-68.5,59.4c-0.2,3.1-0.2,6.1,0,9.2v464.3c-3.8,35.2,21.7,66.8,56.9,70.6c3.9,0.4,7.7,0.5,11.6,0.2h466.5 c35.3,2.6,66.1-23.8,68.7-59.2C1502.5,541.2,1502.5,537.3,1502.1,533.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M1502.1,1426.7V984.5c5.3-36.3-19.9-69.9-56.1-75.2c-6.3-0.9-12.7-0.9-19.1,0H984.7 c-53.1,0-77.4,24.3-77.4,75.2v442.2c0,50.9,22.1,75.2,73,75.2h448.8C1477.7,1501.9,1502.1,1477.6,1502.1,1426.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M1502.1,2328.8v-462.1c3.9-35.2-21.5-66.9-56.7-70.8c-4.7-0.5-9.4-0.5-14,0H967 c-35.3-2.5-66,24-68.5,59.4c-0.2,3.1-0.2,6.1,0,9.2v464.3c-3.8,35.2,21.7,66.8,56.9,70.6c3.9,0.4,7.7,0.5,11.6,0.2h466.5 c35.3,2.6,66.1-23.8,68.7-59.2C1502.5,2336.5,1502.5,2332.7,1502.1,2328.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M1796.1,69.2v464.3c-3.8,35.2,21.7,66.8,56.9,70.6c3.9,0.4,7.7,0.5,11.6,0.2h466.5 c35.3,2.6,66.1-23.8,68.7-59.2c0.3-3.9,0.2-7.7-0.2-11.6V71.4c3.9-35.2-21.5-66.9-56.7-70.8c-4.7-0.5-9.4-0.5-14,0h-464.3 c-35.3-2.5-66,24-68.5,59.4C1795.9,63.1,1795.9,66.1,1796.1,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M2329,1796h-464.3c-35.3-2.5-66,24-68.5,59.4c-0.2,3.1-0.2,6.1,0,9.2v464.3 c-3.8,35.2,21.7,66.8,56.9,70.6c3.9,0.4,7.7,0.5,11.6,0.2h466.5c35.3,2.6,66.1-23.8,68.7-59.2c0.3-3.9,0.2-7.7-0.2-11.6v-462.1 c3.9-35.2-21.5-66.9-56.7-70.8C2338.3,1795.5,2333.6,1795.5,2329,1796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2A2A2"
    },
    d: "M2399.7,1426.7V984.5c5.3-36.3-19.9-69.9-56.1-75.2c-6.3-0.9-12.7-0.9-19.1,0h-442.2 c-53.1,0-77.4,24.3-77.4,75.2v442.2c0,50.9,22.1,75.2,73,75.2h457.7C2375.4,1501.9,2399.7,1477.6,2399.7,1426.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/gridView.055d5f4e9d65ecc5f73ee63b6952e2ae.svg";
export { ForwardRef as ReactComponent };